module.exports = "/images/pin-digital-active.png?e028139d0f0fc2a5831884495a7be91d";